require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./recipes-andhra-murukku.json") })
        }
      }, "path---recipes-andhra-murukku");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---recipes-andhra-murukku!./.cache/json/recipes-andhra-murukku.json
// module id = 725
// module chunks = 231608221292675